import { GET_REPORT_DATA } from './mutation-types'
import relatorioDiretoOperadorHttpService from '../_services/relatorioDiretoOperadorHttpService'

export default {
  gerarRelatorioDiretoOperadorResumido: async ({ commit }, form) => {
    try {
      const [responseTotal, responseDiaCorrido, responseMediaDia, responseHora, responseMediaHora] = await Promise.all([
        relatorioDiretoOperadorHttpService.getRelatorioResumidoDiretoOperadorTotal(form),
        relatorioDiretoOperadorHttpService.getRelatorioResumidoDiretoOperadorDiaCorrido(form),
        relatorioDiretoOperadorHttpService.getRelatorioResumidoDiretoOperadorMediaDia(form),
        relatorioDiretoOperadorHttpService.getRelatorioResumidoDiretoOperadorHora(form),
        relatorioDiretoOperadorHttpService.getRelatorioResumidoDiretoOperadorMediaHora(form),
      ])

      const responseData = []

      for (let i = 0; i < responseTotal.data.length; i++) {
        responseData.push(
          Object.assign(
            {},
            responseTotal.data[i],
            responseDiaCorrido.data[i],
            responseMediaDia.data[i],
            responseHora.data[i],
            responseMediaHora.data[i]
          )
        )
      }

      commit(GET_REPORT_DATA, responseData)
    } catch (e) {
      console.log(e)
    }
  },
}
